import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PURCHASE_INVOICE, CREATE_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

function InvoiceListPageActions({ isPurchase = false }) {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { eInvoiceForm } = useTranslatedMessages();
  const { document_list } = eInvoiceForm;

  const invoiceButtonLabel = isPurchase ? document_list.create_self_billed_invoice : document_list.create_invoice;
  const createPermission = isPurchase ? CREATE_PURCHASE_INVOICE : CREATE_SALE_INVOICE;
  const canCreate = hasEInvoicePermission(createPermission);

  const handleCreateAction = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    return isPurchase ? navigate('/purchases/documents/invoices/create') : navigate('/sales/documents/invoices/create');
  };

  return (
    <>
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          id="create-invoice"
          key="create-new-invoice"
          variant="contained"
          color="primary"
          onClick={handleCreateAction}
          disabled={!canCreate}
        >
          {invoiceButtonLabel}
        </Button>
      </PermissionDeniedWrapper>
      <SubscriptionModal />
    </>
  );
}

export default InvoiceListPageActions;
